import { hotTopics, leadStory, tickers } from '@/mocks/chaoyang';
import { toneBadge, toneDot } from './tones';

function Ticker() {
  return (
    <div className="flex items-stretch overflow-hidden rounded-xl bg-[#2a1a10]">
      <span className="flex shrink-0 items-center gap-1.5 bg-amber-400 px-4 py-2.5 text-xs font-black text-stone-900">
        <i className="ri-pulse-line text-sm"></i>
        现场直击
      </span>
      <div className="relative flex w-full items-center overflow-hidden">
        <div className="chigua-ticker flex w-max items-center gap-10 pl-6">
          {[...tickers, ...tickers].map((t, i) => (
            <span key={i} className="flex shrink-0 items-center gap-2 whitespace-nowrap text-[13px] text-amber-50/90">
              <i className="ri-circle-fill text-[5px] text-amber-400"></i>
              {t}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function Hero() {
  const now = new Date();
  const dateLabel = now.toLocaleDateString('zh-CN', { month: 'long', day: 'numeric', weekday: 'long' });

  return (
    <section id="today" className="chigua-container scroll-mt-24 pt-24 md:pt-28">
      <div className="flex flex-wrap items-end justify-between gap-3 pb-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-500/10 px-3 py-1 text-xs font-bold text-red-600 ring-1 ring-red-500/20">
              <i className="ri-fire-fill text-sm"></i>
              HOT · 实时更新
            </span>
            <span className="text-xs font-medium text-stone-500">{dateLabel}</span>
          </div>
          <h1 className="mt-3 text-2xl font-black tracking-tight text-stone-900 md:text-[34px] md:leading-snug">
            朝阳吃瓜·今日热瓜
          </h1>
          <p className="mt-1.5 text-sm text-stone-600 md:text-[15px]">不用翻论坛，今日新瓜、最新爆料、围观后续一站吃齐。</p>
        </div>
        <span className="text-xs font-medium text-stone-400">朝阳区群众现场视角 · 陆续补充</span>
      </div>

      <Ticker />

      <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="relative group overflow-hidden rounded-2xl lg:col-span-2">
          <img
            src={leadStory.cover}
            alt="三里屯街头网红咖啡车排队的现场画面"
            className="h-[300px] w-full object-cover transition-transform duration-500 group-hover:scale-105 md:h-[380px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
            <div className="mb-3 flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-red-500 px-2 py-1 text-[11px] font-bold text-white">{leadStory.tag}</span>
              <span className="rounded-md bg-white/15 px-2 py-1 text-[11px] font-medium text-white backdrop-blur-sm">{leadStory.area} · 现场</span>
            </div>
            <h2 className="chigua-lead-title text-xl font-black leading-snug text-white md:text-2xl">{leadStory.title}</h2>
            <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-white/85 md:text-sm">{leadStory.summary}</p>
            <div className="mt-3 flex items-center gap-4 text-xs text-white/75">
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-line"></i>
                围观 {leadStory.views}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-chat-3-line"></i>
                {leadStory.comments} 条瓜评
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-time-line"></i>
                {leadStory.time}
              </span>
            </div>
          </div>
        </div>

        <div className="rounded-2xl bg-white p-5 ring-1 ring-orange-500/10">
          <div className="flex items-center justify-between">
            <h3 className="flex items-center gap-2 text-base font-black text-stone-900">
              <i className="ri-bar-chart-box-fill text-lg text-orange-500"></i>
              实时热搜榜
            </h3>
            <button type="button" className="text-xs font-medium text-stone-400 hover:text-orange-600 cursor-pointer" aria-label="刷新">
              <i className="ri-refresh-line mr-1"></i>刷新
            </button>
          </div>
          <ol className="mt-4 space-y-3">
            {hotTopics.map((t) => (
              <li key={t.rank} className="flex items-start gap-3">
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                    t.rank <= 3 ? 'bg-red-500 text-white' : 'bg-black/5 text-stone-500'
                  }`}
                >
                  {t.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-start justify-between gap-2">
                    <p className="line-clamp-2 text-[13px] font-semibold leading-snug text-stone-800">{t.title}</p>
                    <span className="flex shrink-0 items-center gap-1 text-[11px] text-stone-400">
                      <span className={`h-1.5 w-1.5 rounded-full ${toneDot[t.tone]}`}></span>
                      {t.heat}
                    </span>
                  </div>
                  <p className="mt-0.5 text-[11px] text-stone-400">{t.category}</p>
                </div>
              </li>
            ))}
          </ol>
          <p className="mt-4 border-t border-black/5 pt-3 text-center text-[11px] text-stone-400">
            <i className="ri-arrow-down-line mr-1"></i>更多热瓜见下方「今日新瓜」
          </p>
        </div>
      </div>
    </section>
  );
}